module.exports = __webpack_public_path__ + "static/img/cjx11.ad75dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx11.png
// module id = 168
// module chunks = 0